import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Scroll behavior
import ScrollToTop from "./components/ScrollToTop";

// Common layout components
import Navbar from "./components/common/Navbar";
import Contact from "./components/common/Contact";
import Footer from "./components/common/Footer";
import TrustBanner from "./components/common/TrustBanner";

// Legal pages
import Disclaimer from "./components/common/Disclaimer";
import PrivacyPolicy from "./components/common/PrivacyPolicy";
import TermsAndConditions from "./components/common/TermsAndConditions";

// Audience pages
import Allocators from "./components/allocator/Allocators";
import Introduction from "./components/home/Introduction";
import MarketNarrative from "./components/home/MarketNarrative";
import WhiteBannerDivider from "./components/common/WhiteBannerDivider";
import Hero from "./components/home/Hero";


// Investors
import PrivateInvestors from "./components/privateinvestors/PrivateInvestors";

// Partnerships
import Partnerships from "./components/partnerships/PartnerShips";

function App() {
  return (
    <Router>
      {/* Ensures scroll resets on route change */}
      <ScrollToTop />

      <Navbar />

      <Routes>
        {/* Main Landing */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <TrustBanner />
              <Introduction />
              <WhiteBannerDivider />
              <MarketNarrative />
              <Contact />
              <Footer />
            </>
          }
        />

        {/* Allocators (Group Managers) */}
        <Route path="/allocators" element={<Allocators />} />

        {/* Private Investors */}
        <Route path="/investors" element={<PrivateInvestors />} />

        {/* Strategy Partnerships */}
        <Route path="/partnerships" element={<Partnerships />} />

        {/* Legal Pages */}
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      </Routes>
    </Router>
  );
}

export default App;
